import { useState, useEffect } from "react";

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: typeof window != "undefined" ? window?.innerWidth : 300,
    height: typeof window != "undefined" ? window?.innerHeight : 300
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      // eslint-disable-next-line no-inner-declarations
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };
      window.addEventListener("resize", handleResize);
      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return {
    windowSize,
    mobile: windowSize.width < 768,
    tablet: windowSize.width >= 768 && windowSize.width < 1024,
    desktop: windowSize.width >= 1024
  };
}
